"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.prefillFromWorkOrder = exports.prefillFromQuestionContent = void 0;
var types_1 = require("../../types");
var contentParser_1 = require("./contentParser");
var lodash_1 = require("lodash");
var util_1 = require("../util");
var showHide_1 = require("./showHide");
function prefillFromQuestionContent(args) {
    var responses = recursivePrefill(args);
    return responses.map(function (r) { return lodash_1.omit(r, "parentContent"); });
}
exports.prefillFromQuestionContent = prefillFromQuestionContent;
function prefillFromWorkOrder(_a) {
    var workOrder = _a.workOrder, displayConditions = _a.displayConditions, sections = _a.sections, existingResponses = _a.existingResponses, prefillAlternates = _a.prefillAlternates;
    var workOrderConditions = displayConditions.filter(types_1.isWorkOrderPrefillDisplayCondition);
    var responses = __spreadArrays(existingResponses);
    for (var _i = 0, workOrderConditions_1 = workOrderConditions; _i < workOrderConditions_1.length; _i++) {
        var condition = workOrderConditions_1[_i];
        var question = util_1.findOrThrowQuestionByRootId(sections, condition.targetRootId).question;
        var workOrderResponses = contentParser_1.parseResponses(workOrder, condition, question);
        for (var _b = 0, workOrderResponses_1 = workOrderResponses; _b < workOrderResponses_1.length; _b++) {
            var workOrderResponse = workOrderResponses_1[_b];
            responses.push(workOrderResponse);
            if (workOrderResponse.parentContent) {
                responses = recursivePrefill({
                    question: question,
                    content: workOrderResponse.parentContent,
                    displayConditions: displayConditions,
                    sections: sections,
                    existingResponses: responses,
                    prefillAlternates: prefillAlternates,
                });
            }
        }
    }
    return responses.map(function (r) { return lodash_1.omit(r, "parentContent"); });
}
exports.prefillFromWorkOrder = prefillFromWorkOrder;
function recursiveClear(targetQuestionId, targetQuestionRootId, allConditions, sections, existingResponses, previousSourceQuestions) {
    if (previousSourceQuestions === void 0) { previousSourceQuestions = new Set(); }
    previousSourceQuestions.add(targetQuestionId);
    var responses = existingResponses.filter(function (r) { return r.questionId !== targetQuestionId; });
    new Set(allConditions
        .filter(function (c) {
        return (c.action === "SHOW" && c.sourceQuestionRootId === targetQuestionRootId);
    })
        .map(function (c) { return c.targetRootId; })).forEach(function (questionRootId) {
        if (previousSourceQuestions.has(questionRootId)) {
            return;
        }
        var _a = util_1.findOrThrowQuestionByRootId(sections, questionRootId), question = _a.question, section = _a.section;
        if (!showHide_1.isQuestionVisible(question.rootId, section.rootId, responses, allConditions)) {
            responses = recursiveClear(question.id, question.rootId, allConditions, sections, responses, previousSourceQuestions);
        }
    });
    new Set(allConditions
        .filter(function (c) {
        return (c.action === "PREFILL" &&
            c.sourceQuestionRootId === targetQuestionRootId);
    })
        .map(function (c) { return c.targetRootId; })).forEach(function (questionRootId) {
        if (previousSourceQuestions.has(questionRootId)) {
            return;
        }
        var question = util_1.findOrThrowQuestionByRootId(sections, questionRootId).question;
        responses = recursiveClear(question.id, question.rootId, allConditions, sections, responses, previousSourceQuestions);
    });
    return responses;
}
function recursivePrefill(prefillArgs, previousSourceQuestions) {
    if (previousSourceQuestions === void 0) { previousSourceQuestions = new Set(); }
    var question = prefillArgs.question, content = prefillArgs.content, displayConditions = prefillArgs.displayConditions, sections = prefillArgs.sections, existingResponses = prefillArgs.existingResponses, prefillAlternates = prefillArgs.prefillAlternates;
    previousSourceQuestions.add(question.rootId);
    var responses = __spreadArrays(existingResponses);
    var relevantConditions = displayConditions
        .filter(types_1.isPrefillDisplayCondition)
        .filter(function (c) { return c.sourceQuestionRootId === question.rootId; });
    if (relevantConditions.length === 0) {
        return responses;
    }
    for (var _i = 0, relevantConditions_1 = relevantConditions; _i < relevantConditions_1.length; _i++) {
        var condition = relevantConditions_1[_i];
        var _a = util_1.findOrThrowQuestionByRootId(sections, condition.targetRootId), targetQuestion = _a.question, section = _a.section;
        if (!content ||
            !showHide_1.isQuestionVisible(targetQuestion.rootId, section.rootId, responses, displayConditions)) {
            responses = recursiveClear(targetQuestion.id, targetQuestion.rootId, displayConditions, sections, responses);
            continue;
        }
        var questionResponses = contentParser_1.parseResponses(content, condition, targetQuestion, prefillAlternates);
        if (!lodash_1.isEmpty(questionResponses)) {
            responses = addOrOverwriteExistingWithNewResponses(responses, questionResponses, targetQuestion);
            if (!previousSourceQuestions.has(targetQuestion.rootId)) {
                for (var _b = 0, questionResponses_1 = questionResponses; _b < questionResponses_1.length; _b++) {
                    var response = questionResponses_1[_b];
                    responses = recursivePrefill(__assign(__assign({}, prefillArgs), { question: targetQuestion, content: response.parentContent, existingResponses: responses }), previousSourceQuestions);
                }
            }
        }
        else if (util_1.isSingleResponseQuestion(targetQuestion)) {
            responses = recursiveClear(targetQuestion.id, targetQuestion.rootId, displayConditions, sections, responses);
        }
    }
    return responses;
}
function addOrOverwriteExistingWithNewResponses(existingResponses, newResponses, question) {
    var oldResponses = existingResponses.filter(function (r) { return r.questionId === question.id; });
    var otherResponses = existingResponses.filter(function (r) { return r.questionId !== question.id; });
    var finalQuestionResponses = __spreadArrays(oldResponses, newResponses).reverse();
    if (util_1.isSingleResponseQuestion(question)) {
        finalQuestionResponses.splice(1);
    }
    else {
        finalQuestionResponses = lodash_1.uniqBy(finalQuestionResponses, function (a) {
            return a.answer.toLowerCase();
        });
    }
    return __spreadArrays(otherResponses, finalQuestionResponses);
}
//# sourceMappingURL=prefill.js.map